import type { AnimationProperties, AnimationsKit } from '../../../types';

const name = 'FloatOut';
const properties: AnimationProperties = {
  groups: ['exit', 'animation'],
  schema: {
    duration: {
      type: 'number',
      min: 0,
      default: 0,
    },
    delay: {
      type: 'number',
      min: 0,
      default: 0,
    },
    direction: {
      type: 'string',
      enum: ['top', 'right', 'bottom', 'left'],
      default: 'right',
    },
  },
};

const paramsMap = {
  top: { dx: 0, dy: -1, distance: 60 },
  right: { dx: 1, dy: 0, distance: 120 },
  bottom: { dx: 0, dy: 1, distance: 60 },
  left: { dx: -1, dy: 0, distance: 120 },
};

/**
 * FloatIn animation object
 */
function animate(
  kit: AnimationsKit,
  elements: HTMLElement[],
  duration: number,
  delay: number,
  {
    direction = properties.schema.direction.default,
    ...params
  }: { direction?: keyof typeof paramsMap } = {},
) {
  const fromParams = paramsMap[direction];
  const browserViewPortDim = {
    width: kit.frame.innerWidth,
    height: kit.frame.innerHeight,
  };

  const sequence = kit.sequence(params);
  sequence.add(
    kit.animate('BaseFade', elements, duration, delay, {
      from: { opacity: 1 },
      to: { autoAlpha: 0 },
      ease: 'Cubic.easeOut',
    }),
  );

  elements.forEach((element) => {
    const elementViewPortDim = kit.engine.getBoundingRect(element);
    let transformX;
    const transformY = fromParams.dy * fromParams.distance;

    if (fromParams.dx > 0) {
      transformX =
        fromParams.dx *
        Math.max(
          0,
          Math.min(
            browserViewPortDim.width - elementViewPortDim.right,
            fromParams.distance,
          ),
        );
    } else {
      transformX =
        fromParams.dx *
        Math.max(0, Math.min(elementViewPortDim.left, fromParams.distance));
    }

    sequence.add(
      kit.animate('BasePosition', element, duration, delay, {
        to: { x: transformX, y: transformY },
        ease: 'Sine.easeIn',
      }),
      0,
    );
  });

  return sequence.get();
}
export { name, properties, animate };
